import React, { useLayoutEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { subscribeStoreTheme } from '../../../utils/storeTheme';
import { computeVizTones, parseColor, vizVars } from './tones';

/**
 * Οι τόνοι των γραφημάτων για το θέμα που ισχύει ΤΩΡΑ: διαβάζει από τη σελίδα το --brand-ink (ή --brand),
 * το χρώμα του φύλλου (το πραγματικό background του .xs-sheet) και το --text-1, και ξαναϋπολογίζει σε
 * αλλαγή ανοιχτό/σκούρο ή εμφάνισης καταστήματος. Χωρίς υπολογισμένα στυλ (jsdom) → {} και ισχύουν τα
 * εφεδρικά του home.css (το brand με διαφάνεια).
 */
export function useVizTones(rootRef: React.RefObject<HTMLElement | null>, deps: unknown[] = []): React.CSSProperties {
  const { resolved } = useTheme();
  const [storeThemeTick, setStoreThemeTick] = useState(0);
  const [vars, setVars] = useState<Record<string, string>>({});

  useLayoutEffect(() => subscribeStoreTheme(() => setStoreThemeTick(n => n + 1)), []);

  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root || typeof window.getComputedStyle !== 'function') return;
    const css = window.getComputedStyle(root);
    const sheetEl = root.querySelector('.xs-sheet');
    const ink = parseColor(css.getPropertyValue('--brand-ink')) || parseColor(css.getPropertyValue('--brand'));
    const sheet = (sheetEl && parseColor(window.getComputedStyle(sheetEl).backgroundColor))
      || parseColor(css.getPropertyValue('--surface-1'));
    const text1 = parseColor(css.getPropertyValue('--text-1')) || [33, 33, 33];
    if (!ink || !sheet) {
      setVars(prev => (Object.keys(prev).length ? {} : prev));
      return;
    }
    const next = vizVars(computeVizTones(ink, sheet, text1, resolved === 'dark'));
    setVars(prev => (JSON.stringify(prev) === JSON.stringify(next) ? prev : next));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps: θέμα + ό,τι αλλάζει το φύλλο
  }, [resolved, storeThemeTick, ...deps]);

  return vars as React.CSSProperties;
}
